<template>
    <v-card elevation="0" class="my-20px my-md-40px">
        <v-card-title class="tit tit--sm primary--text pt-0">
            <span>캐시리워드 이용안내</span>
        </v-card-title>
        <v-card-text>
            <ul class="disc-list">
                <template v-for="(item, index) in items">
                    <li :key="index" v-html="item" />
                </template>
            </ul>
        </v-card-text>
    </v-card>
</template>

<script>
let items = `
"대한문고 앱" 을 통한 미션 수행 시에만 리워드 캐시 지급이 이루어집니다. (모바일 안드로이드 / IOS 이용 가능)<br/>* 대한문고 앱 최신 버전 업데이트 확인 바랍니다.
모바일 웹 또는 PC를 이용하여 미션 수행을 완료했을 경우 리워드 캐시 지급은 불가합니다.
캐시리워드 충전 내역은 마이페이지 -> 리워드 캐시 내역에서 확인 가능합니다.
로그인 후 참여 가능하며 중복 참여는 불가합니다.
불법적인 경로를 통한 이용으로 인하여 발생하는 문제는 대한문고에서 책임지지 않습니다. 
`
    .split("\n")
    .slice(1, -1);
export default {
    data: () => ({
        items,
    }),
};
</script>

<style lang="scss" scoped>
.disc-list {
    list-style: disc;
    padding-left: 16px;

    & > li::marker {
        font-size: 0.5em;
    }
}
</style>
